import { ExportOptions } from '../../../types/models';
import { ExportConfigSelector } from '../../settings/ExportSettings';

interface ExportConfigBarProps {
	options: ExportOptions;
	onOptionsChange: (options: ExportOptions) => void;
}

export function ExportConfigBar({
	options,
	onOptionsChange,
}: ExportConfigBarProps) {
	const { config } = options;

	// Magazine format doesn't use content config checkboxes
	if (options.format === 'magazine') return null;

	return (
		<div className="w-full">
			<ExportConfigSelector
				value={config}
				onChange={(newConfig) =>
					onOptionsChange({
						...options,
						config: newConfig,
					})
				}
			/>
		</div>
	);
}
